(function(){
    'use strict';

    
    // get the helpful links container if there is one
    var helpful_links_exists = !!document.querySelector('.helpful-links__wrapper');

    // Check that the helpful links exists before doing anything
    if (helpful_links_exists) {

        var all_helpful_links_wrappers = document.querySelectorAll('.helpful-links__wrapper');

        // Loop through all instances of helpful links on the page
        for (var i = 0; i < all_helpful_links_wrappers.length; i++) {

            // Set the current helpful links section
            var helpful_links_section = all_helpful_links_wrappers[i];

            // Initialize the togglers
            initHelpfulLinksTogglers(helpful_links_section);

        }

    }

}());

function initHelpfulLinksTogglers(helpful_links_section) {

    // Get all the elements in the helpful links section
    var helpful_links_togglers = helpful_links_section.querySelectorAll('.helpful-links__toggle');

    // Loop through all instances of helpful links toggler
    for (var i = 0; i < helpful_links_togglers.length; i++) {

        // Add an event listener for on click
        helpful_links_togglers[i].addEventListener('click', function (event) {

            // Toggle the open modifier class on the toggler
            this["classList"].toggle('helpful-links__toggle--open');

            // Get the target element form the toggler
            var target_list = document.querySelector(this["dataset"]["toggle"]);

            // Toggle the targeted list
            target_list["classList"].toggle('helpful-links__inner-list--open');

        });

    }

}
